import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

async function postJson(path, body) {
  const csrfToken = await authService.getCsrfToken();
  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.detail || 'Erro de ligação ao servidor');
  }
  return data;
}

const gamesService = {
  startPenaltyRun() {
    return postJson('/games/penalties/start/');
  },

  shootPenalty(zone) {
    return postJson('/games/penalties/shoot/', { zone });
  },

  async getPenaltyLeaderboard() {
    const response = await fetch(`${API_URL}/games/penalties/leaderboard/`, { credentials: 'include' });
    if (!response.ok) throw new Error('Erro ao carregar o ranking');
    return response.json();
  },
};

export default gamesService;
